import React from "react";
import { useNavigate } from "react-router-dom";
import { IActionMenuProps } from "types";
import { Tooltip } from "components/shared";
import { Trash, ArchiveRestore, Archive, FilePenLine, Eye } from "lucide-react";

export const ActionMenu: React.FC<IActionMenuProps> = ({
  viewRoute,
  row,
  viewModal,
  editRoute,
  modalData,
  editModal,
  deleteAction,
  archiveAction,
  setSelectedItem,
  setDeleteVisible,
  setArchiveVisible,
}) => {
  const navigation = useNavigate();

  return (
    <div className='flex items-center cursor-pointer gap-2'>
      {viewRoute && (
        <Tooltip text='View'>
          <Eye
            className='text-[#ff7b00] hover:scale-125 duration-200 p-1 rounded-md hover:bg-amber-100'
            onClick={() => [
              navigation(viewRoute.replace(':id', row?.reference ?? row?.id)),
            ]}
          />
        </Tooltip>
      )}

      {viewModal && (
        <Tooltip text='View'>
          <Eye
            className='text-[#ff7b00] hover:scale-125 duration-200  p-1 rounded-md hover:bg-amber-100'
            onClick={() => [viewModal(true), modalData(row)]}
          />
        </Tooltip>
      )}

      {editRoute && (
        <Tooltip text='Edit'>
          <FilePenLine
            className=' text-[#2ba32f] hover:scale-125 duration-200  p-1 rounded-md hover:bg-green-100'
            onClick={() => [
              navigation(editRoute.replace(':id', row?.reference ?? row?.id)),
            ]}
          />
        </Tooltip>
      )}

      {editModal && (
        <Tooltip text='Edit'>
          <FilePenLine
            className=' text-[#2ba32f] hover:scale-125 duration-200  p-1 rounded-md hover:bg-green-100'
            onClick={() => [editModal(true), modalData(row)]}
          />
        </Tooltip>
      )}

      {archiveAction &&
        (row?.isActive ? (
          <Tooltip text='Archive'>
            <Archive
              className=' text-[#f00000]  hover:scale-125 duration-200  p-1 rounded-md hover:bg-red-100'
              onClick={() => [setArchiveVisible(true), setSelectedItem(row)]}
            />
          </Tooltip>
        ) : (
          <Tooltip text='Unarchive'>
            <ArchiveRestore
              className='text-gray-700 hover:scale-125 duration-200  p-1 rounded-md hover:bg-red-100'
              onClick={() => [setArchiveVisible(true), setSelectedItem(row)]}
            />
          </Tooltip>
        ))}
      {deleteAction && (
        <Tooltip text='Delete'>
          <Trash
            className='text-[#f00000]  hover:scale-125 duration-200  p-1 rounded-md hover:bg-red-100'
            onClick={() => [setDeleteVisible(true), setSelectedItem(row)]}
          />
        </Tooltip>
      )}
    </div>
  );
};
